import axios from 'axios';

const API_URL = 'https://aws-ads.top/api';

const api = axios.create({
  baseURL: API_URL
});

// 登录接口
export const login = (email, password) => {
  return api.post('/login', { email, password });
};

// 注册接口
export const register = (username, email, password) => {
  return api.post('/register', { username, email, password });
};

// 设置AWS Key
export const setKey = (email, accessKeyId, secretAccessKey) => {
  return api.post('/set-key', { email, accessKeyId, secretAccessKey });
};

// 创建EC2实例
export const createInstance = (region, email) => {
  return api.post('/create-instance', { region, email });
};

// 获取EC2实例列表
export const getInstances = (email) => {
  return api.get(`/instances?email=${email}`);
};

// 终止实例
export const terminateInstance = (instanceId, region, email) => {
  return api.post('/terminate-instance', { instanceId, region, email });
};

// 获取所有弹性IP
export const getElasticIPs = (email) => {
  return api.get(`/elastic-ips?email=${email}`);
};

// 更换IP
export const changeIP = (instanceId, region, email) => {
  return api.post('/change-ip', { instanceId, region, email });
};

// 创建socks5代理
export const createSocks5 = (instanceId, region, email) => {
  return api.post('/create-socks5', { instanceId, region, email });
};

// 释放弹性IP
export const releaseIP = (allocationId, region, email) => {
  return api.post('/release-ip', { allocationId, region, email });
};

// 授权AMI给其他AWS账户
export const authorizeAmiToAccount = (accountId, email) => {
  return api.post('/authorize-ami', { accountId, email });
};

// 释放所有弹性IP
export const releaseAllIPs = (email) => {
  return api.post('/release-all-ips', { email });
};

